export const game = {
    dzpd: {
        plate: "dzpd",
        coupon: "jl",
        title: "川航金熊猫里程兑换蛋仔派对蛋币",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/dzpd/banner.png",
        jingle: "蛋仔派对蛋币兑换",
        icon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/dzpd/icon.png",
        name: "蛋仔派对",
        productImg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/dzpd/product.png",
        productImgAvatar: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/dzpd/avatar.png",
        recharge_tabs_img: [require('@/assets/images/dzpd/recharge.png'), require('@/assets/images/dzpd/write.png')],
        recharge_image_content: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/dzpd/rechargeContents.png",
        unit: "蛋币",
        input_tag: "游戏角色ID",
        isIos: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        sysTips: "仅支持IOS系统充值",
        tips: "蛋仔游戏角色ID",
        rechargeText: [
            {
                name: "",
                titles: [
                    "里程兑换蛋币不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用，不可转赠给他人使用；",
                    '本商品为直充产品，兑换时需要<span class="required">确认填写</span>进行充值的<span class="required">【蛋仔派对】游戏角色编号</span>，游戏角色编号为数字ID；',
                    '请仔细确认游戏角色编号的正确性，因游戏角色编号输入错误导致的充值错误，由会员本人承担；',
                    '游戏角色编号查找方式为：打开<span class="required">“蛋仔派对”APP→登录游戏→点击左上角“个人中心”→蛋仔档案→编号</span>；',
                    '如遇蛋币不能正常兑换或使用，请拨打服务热线：4000-360-195。'
                ]
            },
            {
                name: "使用说明",
                titles: [
                    '蛋币使用范围：目前只支持<span class="required">苹果IOS系统充值，安卓等暂不支持</span>；',
                    '蛋币使用规则：使用蛋币兑换游戏内的外观、道具等产品需要满足产品页面展示的蛋币数量；',
                    '蛋币查看及使用：打开“蛋仔派对”APP--登录游戏--点击菜单栏“商城”，进入即可查看对应的蛋币数量，使用蛋币选择对应的外观、道具等产品进行购买；',
                    '本平台仅是提供会员与商户之间的服务平台，最终商品的解释权，请及时与商户联系。'
                ]
            }
        ],
        successImg: require('@/assets/images/dzpd/success.png'),
        //项目基础样式
        style: {
            "--view-exchange-color": "#FCA400",
            "--view-background-color": "#FFEEC0",
            "--view-copy-right-color": "#EE8743",
            "--view-recharg-background-color": "#FFEEC0",
            "--view-product-lst-border-color": "#FCE694",
            "--view-product-value-background-color": "linear-gradient(90deg, rgba(250, 132, 255, 1) 0%, rgba(255, 209, 213, 1) 54.43%, rgba(255, 255, 161, 1) 100%)",
            "--view-product-value-color": "#8200A1",
            "--view-product-user-pay-account-tips": "#FDAD00",
            "--view-product-user-pay-account-tips-border": "1px solid #FDAD00",
            '--view-product-success-color': '#FF8E1A',
            '--view-product-success-btn-success-background': 'linear-gradient(180deg, rgba(214, 19, 19, 1), rgba(252, 182, 0, 1))',
            '--view-product-success-btn-success-color': '#ffffff',
            '--view-product-success-btn-cancel-background': 'linear-gradient(180deg, rgba(176, 176, 176, 1), rgba(209, 209, 209, 1))',
            '--view-product-success-btn-cancel-color': '#000000',
        }
    },
    qyjsq: {
        plate: "qyjsq",
        coupon: "jl",
        title: "川航金熊猫里程兑换奇游加速器会员",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/qyjsq/banner.png",
        jingle: "奇游加速器",
        icon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/qyjsq/icon.png",
        name: "奇游加速器",
        productImg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/qyjsq/product.png",
        productImgAvatar: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/qyjsq/avatar.png",
        recharge_tabs_img: [require('@/assets/images/qyjsq/recharge.png'), require('@/assets/images/qyjsq/write.png')],
        recharge_image_content: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/game/qyjsq/rechargeContents.png",
        unit: "",
        input_tag: "充值账号",
        isIos: true,
        sysTips: "仅支持IOS系统充值",
        tips: "奇游加速器会员手机号",
        rechargeText: [
            {
                name: "",
                titles: [
                    "里程兑换商品不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用，不可转赠给他人使用；",
                    '本商品为直充产品，兑换时需要填写进行充值的<span class="required">奇游加速器会员手机号</span>；',
                    '请仔细确认奇游加速器会员手机号，因奇游加速器会员手机号输入错误导致的充值错误，由会员本人承担；',
                    '如遇商品不能正常兑换或使用，请拨打服务热线：4000-360-195。'
                ]
            },
            {
                name: "使用说明",
                titles: [
                    '商品使用范围：本商品为网游产品，<span class="required">仅支持PC端，不支持手游端；</span>',
                    '商品使用规则：打开“奇游加速器PC端--点击登录--选择要加速的游戏--点击“加速”即可；',
                    '本平台仅是提供会员与商户之间的服务平台，最终商品的解释权，请及时与商户联系。'
                ]
            }
        ],
        successImg: require('@/assets/images/qyjsq/success.png'),
        //项目基础样式
        style: {
            "--view-exchange-color": "#089964",
            "--view-background-color": "#ACDAC9",
            "--view-copy-right-color": "#106345",
            "--view-recharg-background-color": "#ACDAC9",
            "--view-product-lst-border-color": "#ADFFE2",
            "--view-product-value-background-color": "#17EC9F",
            "--view-product-value-color": "#ffffff",
            "--view-product-user-pay-account-tips": "#51AA45",
            "--view-product-user-pay-account-tips-border": "1px solid #51AA45",
            '--view-product-success-color': '#099A64',
            '--view-product-success-btn-success-background': '#099A64',
            '--view-product-success-btn-success-color': '#ffffff',
            '--view-product-success-btn-cancel-background': '#D2D2D2',
            '--view-product-success-btn-cancel-color': '#000000',
        }
    }
}
